import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CoupanServices from '../../services/CoupanServices';

function AddCoupanNew() {
    const navigate = useNavigate();

    const [formValues, setFormValues] = useState({
        name: '',
        description: '',
        upto: '',
        numberOfCoupons: '',
        endDate: '',
        price: '',
        discountType: '',
        maxDiscountAmount: '',
        sequence:'',
        actualPrice:"",
        discountPrice:"",
        termsAndConditions: '',
        totalnumberOfusagesCoupons: '',
        totalnumberOfusagesperuserCoupons: '',
        categoryId: '',
        serviceId: '',
        vendorId: '',
        image: ""
    });
    const [categories, setCategories] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    // Handle form input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // Reset dependent dropdowns when parent changes
        if (name === 'categoryId') {
            setFormValues({
                ...formValues,
                categoryId: value,
                vendorId: '',  // Reset vendor when category changes
                serviceId: ''   // Reset service when category changes
            });
        } else if (name === 'vendorId') {
            setFormValues({
                ...formValues,
                vendorId: value,
                serviceId: ''   // Reset service when vendor changes
            });
        } else {
            setFormValues({
                ...formValues,
                [name]: value,
            });
        }
    };

    useEffect(() => {
        // Fetch categories
        CoupanServices.getMembershipCategories()
            .then(res => {
                if (res.status) setCategories(res.data);
            })
            .catch(error => {
                console.error('Failed to fetch categories', error);
            });

        // Fetch vendors
        CoupanServices.getActiveVendors()
            .then(res => {
                if (res.status) setVendors(res.data);
            })
            .catch(error => {
                console.error('Failed to fetch vendors', error);
            });
    }, []);

    // Fetch services when vendor is selected
    useEffect(() => {
        if (formValues.vendorId) {
            fetchServicesByVendor(formValues.vendorId);
        } else {
            setServices([]); // Clear services when no vendor selected
        }
    }, [formValues.vendorId]);

    const fetchServicesByVendor = async (vendorId) => {
        try {
            const response = await CoupanServices.getVendorByServices(vendorId);
            if (response.status) {
                setServices(response.data);
            } else {
                setServices([]);
            }
        } catch (error) {
            console.error('Failed to fetch services', error);
            setServices([]);
        }
    };

    const validateForm = () => {
        const { endDate, categoryId, serviceId, vendorId, name, price } = formValues;
        const currentDate = new Date();
        const selectedEndDate = new Date(endDate);

        // Ensure the end date is not earlier than the current date
        if (selectedEndDate < currentDate.setHours(0, 0, 0, 0)) {
            alert('End Date cannot be earlier than today.');
            return false;
        }

        // Validate category selection
        if (!categoryId) {
            alert('Please select a category.');
            return false;
        }

        // Validate vendor selection
        if (!vendorId) {
            alert('Please select a vendor.');
            return false;
        }

        // Validate service selection
        if (!serviceId) {
            alert('Please select a service.');
            return false;
        }

        // Validate coupon name
        // if (!name.trim()) {
        //     alert('Please enter coupon code name.');
        //     return false;
        // }

        // Validate minimum amount
        // if (!price || price <= 0) {
        //     alert('Please enter minimum services amount.');
        //     return false;
        // }

        return true;
    };

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) return;

        setLoading(true);

        try {
            // Prepare the data for API
            // const submitData = {
            //     categoryId: formValues.categoryId,
            //     serviceId: formValues.serviceId,
            //     vendorId: formValues.vendorId,
            //     name: formValues.name.trim(),
            //     upto: formValues.upto ? Number(formValues.upto) : 0,
            //     totalnumberOfusagesCoupons: formValues.totalnumberOfusagesCoupons ? Number(formValues.totalnumberOfusagesCoupons) : 0,
            //     totalnumberOfusagesperuserCoupons: formValues.totalnumberOfusagesperuserCoupons ? Number(formValues.totalnumberOfusagesperuserCoupons) : 0,
            //     coupanCounter: 0,
            //     endDate: formValues.endDate,
            //     price: formValues.price ? Number(formValues.price) : 0,
            //     maxDiscountAmount: formValues.maxDiscountAmount ? Number(formValues.maxDiscountAmount) : 0,
            //     termsAndConditions: formValues.termsAndConditions,
            //     status: "Active"
            // };
            const formData = new FormData();
            formData.append("categoryId", formValues.categoryId);
            formData.append("serviceId", formValues.serviceId);
            formData.append("vendorId", formValues.vendorId);
            formData.append("name", formValues.name);
            formData.append("description", formValues.description);
            formData.append("endDate", formValues.endDate);
            formData.append("termsAndConditions", formValues.termsAndConditions);
            formData.append("upto", Number(formValues.upto) || 0);
            formData.append("price", Number(formValues.price) || 0);
            formData.append("maxDiscountAmount", Number(formValues.maxDiscountAmount) || 0);
            formData.append("sequence", Number(formValues.sequence) || 0);
            formData.append("discountPrice", Number(formValues.discountPrice) || 0);
            formData.append("actualPrice", Number(formValues.actualPrice) || 0);
            formData.append("totalnumberOfusagesCoupons", Number(formValues.totalnumberOfusagesCoupons) || 0);
            formData.append("totalnumberOfusagesperuserCoupons", Number(formValues.totalnumberOfusagesperuserCoupons) || 0);
            if (formValues.image) {
                formData.append("image", formValues.image);
            }
            // await CoupanServices.createCoupan(submitData);
            await CoupanServices.createCoupan(formData);
            alert('Coupon created successfully');
            navigate('/couponnew');
        } catch (error) {
            console.error('Failed to create Coupon', error);
            alert(error.response?.data?.message || 'Failed to create Coupon');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                    <div className="my-auto">
                        <h5 className="page-title fs-21 mb-1">
                            New Generate Coupon Code
                        </h5>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Generate Coupon Code
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <Link className="list-banner-btn" to="/couponnew">Coupon Code List</Link>
                    </div>
                </div>

                <div className="container-box">
                    <div className="container-box-inner table-reponsive-tabe">
                        <div className="page-details">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    {/* Category Dropdown */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Category<span className="red">*</span></label>
                                            <select
                                                name="categoryId"
                                                className="form-control"
                                                value={formValues.categoryId}
                                                onChange={handleInputChange}
                                                
                                            >
                                                <option value="">Select Category</option>
                                                {categories.map((category) => (
                                                    <option key={category._id} value={category._id}>
                                                        {category.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Vendor Dropdown */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Vendor<span className="red">*</span></label>
                                            <select
                                                name="vendorId"
                                                className="form-control"
                                                value={formValues.vendorId}
                                                onChange={handleInputChange}
                                             
                                                disabled={!formValues.categoryId}
                                            >
                                                <option value="">Select Vendor</option>
                                                {vendors.map((vendor) => (
                                                    <option key={vendor._id} value={vendor._id}>
                                                        {vendor.name || vendor.businessName || vendor.fullName || 'Vendor'}
                                                    </option>
                                                ))}
                                            </select>
                                            {!formValues.categoryId && (
                                                <small className="text-muted">Please select category first</small>
                                            )}
                                        </div>
                                    </div>

                                    {/* Service Dropdown */}
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Service<span className=""></span></label>
                                            <select
                                                name="serviceId"
                                                className="form-control"
                                                value={formValues.serviceId}
                                                onChange={handleInputChange}
                                              
                                                disabled={!formValues.vendorId}
                                            >
                                                <option value="">Select Service</option>
                                                {services.map((service) => (
                                                    <option key={service._id} value={service._id}>
                                                        {service.title}
                                                    </option>
                                                ))}
                                            </select>
                                            {!formValues.vendorId && formValues.categoryId && (
                                                <small className="text-muted">Please select vendor first</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-12">
                                        <div className="input-field">
                                            <label>Coupon Code Name<span className=""></span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={formValues.name}
                                                onChange={handleInputChange}
                                                placeholder="Enter coupon code name (e.g., WELCOME50)"
                                       
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Discount Value (%)</label>
                                            <input
                                                type="number"
                                                name="upto"
                                                className="form-control"
                                                value={formValues.upto}
                                                onChange={handleInputChange}
                                                placeholder="5%"
                                                min="0"
                                                max="100"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-3">
                                        <div className="input-field">
                                            <label>Minimum Services Amount <span className=""></span></label>
                                            <input
                                                type="number"
                                                name="price"
                                                className="form-control"
                                                value={formValues.price}
                                                onChange={handleInputChange}
                                                placeholder="₹ 1500"

                                                min="0"
                                                step="1"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>MAX Discount Amount</label>
                                            <input
                                                type="number"
                                                name="maxDiscountAmount"
                                                className="form-control"
                                                value={formValues.maxDiscountAmount}
                                                onChange={handleInputChange}
                                                placeholder="300"
                                                min="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Add Sequence</label>
                                            <input
                                                type="number"
                                                name="sequence"
                                                className="form-control"
                                                value={formValues.sequence}
                                                onChange={handleInputChange}
                                                placeholder=""
                                                min="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Actual Price</label>
                                            <input
                                                type="number"
                                                name="actualPrice"
                                                className="form-control"
                                                value={formValues.actualPrice}
                                                onChange={handleInputChange}
                                                placeholder=""
                                                min="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Discount Price</label>
                                            <input
                                                type="number"
                                                name="discountPrice"
                                                className="form-control"
                                                value={formValues.discountPrice}
                                                onChange={handleInputChange}
                                                placeholder=""
                                                min="0"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Expire Date<span className=""></span></label>
                                            <input
                                                type="date"
                                                name="endDate"
                                                className="form-control"
                                                value={formValues.endDate}
                                                onChange={handleInputChange}
                                              
                                                min={new Date().toISOString().split('T')[0]}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of Usage Limit</label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesCoupons}
                                                onChange={handleInputChange}
                                                placeholder="10"
                                                min="0"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                        <div className="input-field">
                                            <label>Total Number of usage per user</label>
                                            <input
                                                type="number"
                                                name="totalnumberOfusagesperuserCoupons"
                                                className="form-control"
                                                value={formValues.totalnumberOfusagesperuserCoupons}
                                                onChange={handleInputChange}
                                                placeholder="2"
                                                min="0"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-6">
                                           <div className="input-field">
                                          <label>Image:</label>
                                        <input
                                            type="file"
                                            name="image"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setFormValues(prev => ({
                                                        ...prev,
                                                        image: file
                                                    }));
                                                    setImagePreview(URL.createObjectURL(file));
                                                } else {
                                                    setFormValues(prev => ({
                                                        ...prev,
                                                        image: ""
                                                    }));
                                                    setImagePreview(null);
                                                }
                                            }}
                                        />
                                        {imagePreview && (
                                            <div style={{ marginTop: "10px" }}>
                                                <img
                                                    src={imagePreview}
                                                    alt="Preview"
                                                    style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "8px", border: "1px solid #ccc" }}
                                                />
                                            </div>
                                        )}
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-sm-12">
                                        <div className="input-field">
                                            <label>Terms And Conditions</label>
                                            <textarea
                                                className="form-control video-desc h-auto"
                                                name="termsAndConditions"
                                                value={formValues.termsAndConditions}
                                                onChange={handleInputChange}
                                                placeholder="Enter Terms And Conditions"
                                                rows="4"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="text-center mt-4">
                                    <button
                                        className="submit-green-btn"
                                        type="submit"
                                        disabled={loading}
                                        style={{ minWidth: '150px' }}
                                    >
                                        {loading ? 'SUBMITTING...' : 'SUBMIT'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AddCoupanNew;